import React, { useState } from "react";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";
import Share2EarnModal from "@/components/modals/Share2EarnModal";
import { useGetGleamActions } from "@/hooks/useGetGleamActions";
import styles from "./ActionCards.module.scss";

interface SocialShareCardProps {
    xpReward?: number;
    onModalOpen?: () => void;
    onModalClose?: () => void;
}

const SocialShareCard: React.FC<SocialShareCardProps> = ({ xpReward = 100, onModalOpen, onModalClose }) => {
    const [showGleamModal, setShowGleamModal] = useState(false);
    const currentUser = useSelector((store: IStore) => store.metaStore.currentUser);
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    // Get Gleam actions data
    const { data: gleamActionsData } = useGetGleamActions(fullToken ? currentUser?.user?.email : "NOT_LOGGED_IN");
    const gleamActions = gleamActionsData?.actions || [];

    // Count available actions
    const availableActions = gleamActions.filter((action: any) => !action.completed).length;
    const completedActions = gleamActions.filter((action: any) => action.completed).length;
    const totalEntries = gleamActions.reduce((sum: number, action: any) => sum + (action.entries || 0), 0);

    const handleOpenGleam = () => {
        setShowGleamModal(true);
        if (onModalOpen) onModalOpen();
    };

    const handleCloseGleam = () => {
        setShowGleamModal(false);
        // Could add XP calculation logic here like in GoVipShare2Earn
        if (onModalClose) onModalClose();
    };

    return (
        <>
            <div
                className="stat-card"
                onClick={handleOpenGleam}
                style={{
                    cursor: "pointer",
                    backgroundImage: `url(${import.meta.env.VITE_CDN_URL}/images/card-bck9.png)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    border: "1px solid rgba(120, 89, 230, 0.3)",
                    position: "relative",
                }}
            >
                <div style={{
                    position: "absolute",
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(0, 0, 0, 0.4)",
                    borderRadius: "inherit",
                }}></div>
                <div style={{ position: "relative", zIndex: 1 }}>
                    <h4 style={{ color: "white", textShadow: "0 2px 4px rgba(0, 0, 0, 0.9)", fontWeight: "700", letterSpacing: "0.5px" }}>📯 SHARE & EARN</h4>
                    <div className="stat-value" style={{ color: "#FFFFFF", textShadow: "0 2px 4px rgba(0, 0, 0, 0.9)", fontWeight: "700", fontSize: "1.1rem" }}>
                        {availableActions > 0 ? `${availableActions}` : "0"}
                    </div>
                    <div className="stat-subtitle" style={{ color: "rgba(255, 255, 255, 0.95)", textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)", fontWeight: "500" }}>
                        {availableActions > 0 ? "Actions Available" : "Check Actions"}
                    </div>
                </div>
            </div>

            {/* Gleam Modal */}
            {showGleamModal &&
        <Share2EarnModal
            isOpen={showGleamModal}
            toggle={handleCloseGleam}
        />
            }
        </>
    );
};

export default SocialShareCard;